import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl } from '@angular/forms';
import { TabConst } from 'src/app/tabms/tab-consts';

@Component({
  selector: 'app-mat-time-picker',
  templateUrl: './mat-time-picker.component.html',
  styleUrl: './mat-time-picker.component.scss'
})
export class MatTimePickerComponent {
  formControl: FormControl<Date | null>;
  label: string

  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE;

  constructor() {
    const initialValue = new Date();
    initialValue.setHours(12, 30, 0);
    this.formControl = new FormControl(initialValue);
  }
}
